import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const EiLensProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="Emotional Intelligence Assessment Nigeria | EI Lens™ Lagos"
        description="EI Lens™ emotional intelligence assessment for Nigerian leaders. Measure how a leader handles emotion, their own and other people's. Validated EI profiling built for African leadership contexts."
        keywords="emotional intelligence assessment Nigeria, EI test Lagos, EQ assessment Nigeria, leadership emotional intelligence Africa, EI Lens"
        canonical="https://impactasportal.com/product/ei-lens"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/ei-lens?embed=true"
            title="EI Lens™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default EiLensProductPage;
